// extracted by mini-css-extract-plugin
export default {"title":"News&EventsViewLoading_title__1Fz4v","description":"News&EventsViewLoading_description__QHzRO"};